<template>
  <i>Server is up and running</i>
</template>

<script>
export default {
  name: 'healthCheck',
  data () {
    return {
      loading: true
    }
  },
  methods: {
    
  }
}
</script>
